/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, SelectionControlLabel } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import { params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import classNames from 'classnames';
import { HOME_DEPOT_QUOTE_CENTER } from '../../constants';

export const ProductCompare = ({
  onCompare,
  onSelectedForCompare,
  selectedForCompare,
  itemId,
  tap,
  noMargin,
  flexPosition,
  disableCompare
}) => {
  const { additionalData } = useImpression({
    data: {
      id: itemId,
      component: 'ProductCompare',
      name: 'ProductCompare',
      position: 0
    }
  });

  const { parent } = additionalData || {};

  const MAX_COMPARABLE = 4;
  const MIN_COMPARABLE = 2;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(selectedForCompare.includes(itemId));
  }, [selectedForCompare, itemId]);

  const onChange = () => {
    setChecked(!checked);
    onSelectedForCompare(itemId, !checked);
    LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.compare', {
      podAction: 'product compare',
      podAnchorSku: itemId,
      parent
    });
  };

  const { data } = useDataModel('product', {
    variables: {
      itemId
    }
  });

  const { productSubType } = data?.product?.info || {};

  const isHDQCSku = productSubType?.name === HOME_DEPOT_QUOTE_CENTER;
  const compareClass = classNames(flexPosition,
    'sui-w-full sui-flex sui-items-center sui-h-11 sui-gap-x-1 sui-justify-center',
    {
      'sui-mt-2': !noMargin
    });
  const showCompareNowButton = checked && selectedForCompare?.length >= MIN_COMPARABLE;
  const tapperClass = classNames('sui-items-center sui-flex', { 'sui-z-20': tap });

  return (
    <div className={compareClass}>
      <div className={tapperClass} data-testid="product-compare-label">
        <SelectionControlLabel label={(showCompareNowButton) ? '' : 'Compare'}>
          <Checkbox
            checked={checked}
            onChange={onChange}
            inputAttributes={{ 'aria-label': 'product-compare-checkbox' }}
            id={`compare-${itemId}`}
            disabled={disableCompare || (!checked && selectedForCompare?.length >= MAX_COMPARABLE)}
            value={`compare-${itemId}`}
          />
        </SelectionControlLabel>
        {showCompareNowButton && (
          <div className="sui-ml-[-16px]">
            <Button
              variant="text"
              buttonSize="tight"
              onClick={onCompare}
              fullWidth
            >
              Compare Now
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

ProductCompare.displayName = 'ProductCompareDeprecated';

ProductCompare.dataModel = {
  product: params({
    itemId: string().isRequired()
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      productSubType: shape({
        name: string()
      })
    })
  })
};

ProductCompare.propTypes = {
  onCompare: PropTypes.func,
  onSelectedForCompare: PropTypes.func,
  selectedForCompare: PropTypes.arrayOf(PropTypes.string),
  itemId: PropTypes.string.isRequired,
  tap: PropTypes.bool,
  noMargin: PropTypes.bool,
  flexPosition: PropTypes.string,
  disableCompare: PropTypes.bool
};

ProductCompare.defaultProps = {
  onCompare: () => { },
  onSelectedForCompare: () => { },
  selectedForCompare: [],
  noMargin: false,
  flexPosition: null,
  tap: false,
  disableCompare: false
};
